module.exports = __webpack_public_path__ + "img/ls.60e1e84a.svg";